module.exports = __webpack_public_path__ + "img/eight4Blue.4d8eea1b.jpg";